module.exports = __webpack_public_path__ + "static/media/diario_classe_portal.5d09e7df.pdf";